module.exports = __webpack_public_path__ + "img/54000.421b3df2.jpg";